import { useEffect, useContext} from "react"
import { useLocation } from "react-router-dom";
import {useEstadoApp} from "../context/EstadoAppContext";
import { AuthContext } from "../context/authContext";

import { MapaEntidades } from "../components/MapaEntidades";

export const MapaPrivPage = () => {
    const location = useLocation();
    const {estadoAppX, cambiarEstadoApp} = useEstadoApp();
    const { role, userMunicipio } = useContext(AuthContext);
    
    // Datos pasados desde TablaRed al navegar
    const mapData = location.state;

    useEffect(() => {
        //console.log("estadoAppX", estadoAppX)
        cambiarEstadoApp("inicial")
    }, []) //cuando se monta el componente volver al estado inicial
    //const {isAuthenticated} = useContext(AuthContext)    

    return (
        <div className="h-full w-full overflow-hidden">
            <MapaEntidades mode="private"
                className="h-full w-full" 
                zoomTo={mapData}
                filterByMunicipio={role === 'editor_municipio' ? userMunicipio : null}
            />
        </div>
    )
}